/**
 * Notes:
 * 1. Please keep the '|' separator in the text, which is required in some parts of the website.
 * 2. Please try to translate in context, and reject machine translation.
 * 3. please use this simplified Chinese as the basic translation, other languages as the basic translation may have ambiguity or blurred meaning, etc.
 */
// import version from '@/core/version'

export const all = {// Generic data
    loading: 'Pulling the data needed for the page...'
}

export const navbar = {
    nav_index: 'Home',
    nav_down: 'Download',
    nav_state: 'Status',
    nav_donate: 'Sponsored',
    nav_about: 'About',
    nav_rank: 'Ranking'
}

export const navigation = {
    tab_unemail: 'Email not verified',
    tab_toLogin: 'login',
    tab_logout: 'Logout',
    tab_dashborad: 'Dashboard',
    tab_icloud: 'Sync Service',
    tab_skin: 'My skin',
    tab_account: 'My account',
    tab_games: 'My games',
    tab_set_night: 'Night mode'
}

export const footer = {
    copy: 'Copyright ©{year} {strong} All rights reserved. {miit}',
    co: 'MAKjust',
    tra: '"Minecraft" are trademarks of Mojang Studios, the copyright of the Minecraft game itself belongs to Mojang Studios.',
    developer: 'developer',
    we: 'we',
    link: 'friendly link',
}

export const index = {
    msg_welcome: 'Welcome to the MAKjust minecraft server',
    msg_welcome_text: 'This is a pure original survival server, with the same survival as the original, and with villages and settlements built up by players. Here, you just need to have fun, we only target violations such as plug-ins, and will not interfere with the game experience.' ,
    msg_welcome_actions: 'Dashboard|Sign in',
    msg_join: 'Join MAKjust QQ group',
    msg_join_text: 'Communicate with players, get first-hand official news, and contact us with feedback in the group.' ,
    msg_join_actions: 'Click to join the group',
    news_title: 'News|from MCBBS',
    news_down: 'Failed to get news.' ,
    news_stop: 'Temporarily unavailable due to MCBBS news API revision.' ,
    post_title: 'Announcement',
    post_down: 'Failed to get the announcement.'
}

export const dl = {
    title: 'Download Center',
    note: 'Here you can download the latest version of the MAKjust client, as well as standalone game packs, mods, developer SDKs, plugin demos, etc.' ,
    version: 'Version:',
    release: 'Release Notes',
    //official_client
    official_title: 'Official launcher',
    official_new_note: 'Official release of the full launcher client with MAKjusntID integration, fast, simple and lightweight.' ,
    official_new_rt: 'Interface-less basic client core that can be managed via "{iconList}" -> {iconGames} My Games -> Nyan Online.' ,
    official_new_ux: 'Client that adds a separate UI and can be used in a network-less environment.' ,
    official_old_title: 'Older version in release' ,
    official_historyVer: 'History version',
    //Third-party Luncher
    luncher_title: 'Launcher (third-party)',
    luncher_tip: 'Recommended only, sorted in no particular order',
    luncher_download_tip: 'Please make your own selection, we are not responsible for any consequences caused by your download and use of third-party launchers.' ,
    //java
    java_title: 'Java Download',
    java_note: 'Dependencies required to run Minecraft, we provide the official download channel, click to go to the official website to download.' ,
    //mods
    mods_title: 'Modules (MOD)',
    //light and shadow
    shadow_title: 'Shadow',
    //Button
    btn_stayTuned: 'Please wait',
    btn_toDownload: 'Go to download',
    btn_download: 'Free download',
    btn_online: 'Manage Online',
    btn_noDownload: 'No download channel for now',
}

export const status = {
    title: 'MAKjust Status',
    note: 'We will check if the services are working every 5 minutes, these data are generated automatically by the checkpoint, this page will update the data every minute.' ,
    gameServer: 'Game Server',
    gameServer_status: 'Status',
    gameServer_live: 'Number of people online',
    dataServer: 'dataServer',
    dataServer_error: 'Failed to get monitoring status, please try refreshing the page.',
    dataServer_60day: 'Average online rate in the last 60 days',
    dataServer_online: 'Online',
    dataServer_offline: 'offline',
}

export const about = {
    title: 'About',
    subtitle: 'A quiet Minecraft server',
    readme: 'MAKjust Minecraft server was established in 2014, when the PE server. 2015 due to a variety of strange and bizarre reasons to stop serving a year, in June 2016 began to re-plan and build the PC side of the server, now has been in the bump goo goo go through the| years, the thing is now people are old, want to quietly open a Small service, a retirement service that does not close, by the way, the server to do some of the experimental service ready to open source projects. We version updates generally come with the official, if you can not change the map, generally for the preservation of the archive, there is no way to partially retain the items.' ,
    donate_title: "We're a porcelain company",
    donate_text: 'Thank you very much for understanding how difficult it is for us. {strong1}We are maintaining a {strong2} server for {strong1}, so we are only accepting {strong3} sponsorships. The majority (≥90%) of the sponsorship proceeds will be used to keep the Minecraft server running consistently. A small portion (≤10%) will be used to subsidize the team pigeons (developers). {br}We support sponsorship using the Love Power channel, please note your email or ID when sponsoring so we can do the statistics.' ,
    donate_strong: 'public benefit|non-profit|unconditional',
    donate_afdian: 'Love power generation',
    donate_wechat: 'WeChat',
    donate_list: 'list of sponsors',
    donate_tHead: 'Sponsors|Channels|Amount',
    donate_loading: 'Getting the list of sponsors...' ,
    donate_error: 'An error occurred while fetching the list of sponsors.' ,
    donate_channels: 'afdian|WeChat|Alipay|QQPay'

}

//Translated with www.DeepL.com/Translator (free version)